import { IoIosContact } from "react-icons/io";
// import { BsWindow } from "react-icons/bs";
import { CgShoppingBag } from "react-icons/cg";

import { Home, Apple } from "lucide-react";
import MyLife from "../assests/projects_img/life_ratings.png";
import karzaHasna from "../assests/projects_img/karza_hasna.png";
import RnP from "../assests/projects_img/react_native_portfolio.png";
import habitual_fact from "../assests/projects_img/habitual_fact.png";
import bhasha_switch from "../assests/projects_img/vasha.png";

// ----------------------  Navbar data start -----------------------------------
const navLinks = [
  { to: "/", icon: <Home size={20} /> },
  { to: "/about", icon: <IoIosContact size={20} /> },
  { to: "/webapps", icon: <CgShoppingBag size={20} /> },
  { to: "/mobileapps", icon: <Apple size={20} /> },
];

export default navLinks;

// export let reactNativeProjectData = [
//   {
//     num: "01",
//     // category: "Mobile App(UI)",
//     title: "Nutrition & Diet Mobile App",
//     description: `Perfect for anyone looking to lead a healthier lifestyle.`,
//     stack: [
//       { name: "React Native" },
//       { name: "Reanimated" },
//       { name: "Only UI" },
//     ],
//     img: healthApp,
//     live: "",
//     github: "",
//   },
//   {
//     num: "02",
//     // category: "Mobile App(UI)",
//     title: "Nutrition & Diet Mobile App",
//     description: `Perfect for anyone looking to lead a healthier lifestyle.`,
//     stack: [
//       { name: "React Native" },
//       { name: "Reanimated" },
//       { name: "Only UI" },
//     ],
//     img: healthApp,
//     live: "",
//     github: "",
//   },
// ];

// ----------------------------  React JS Project data ------------------

export let reactProjectData = [
  {
    num: "01",
    // category: "Front End",
    title: "Life Ratings App",
    description: `It allows you to increase your progress, just for fun!`,
    stack: [{ name: "React Js" }, { name: "CSS" }],
    img: MyLife,
    live: "https://jazzy-sorbet-eea605.netlify.app/",
    github: "https://jazzy-sorbet-eea605.netlify.app/",
  },

  {
    num: "02",
    // category: "Front End",
    title: "Karz-e-Hasna App",
    description: `Qarz-e-Hasna is to enhance society's socioeconomic status`,
    stack: [
      { name: "React Js" },
      { name: "CSS" },
      { name: "React Router DOM" },
    ],
    img: karzaHasna,
    live: "https://timely-granita-c7445f.netlify.app/",
    github: "https://timely-granita-c7445f.netlify.app/",
  },

  {
    num: "03",
    // category: "Front End",
    title: "React Native",
    description: `I want to Become a Mobile App Software Engineer.`,
    stack: [
      { name: "React Js" },
      { name: "Tailwind" },
      { name: "React Router DOM" },
    ],
    img: RnP,
    live: "https://radiant-pixie-37e4fc.netlify.app/",
    github: "https://github.com/shihab-sa/shihabrn",
  },
  {
    num: "04",
    // category: "Front End",
    title: "Habitual fact App",
    description: `An easy productivity hack Tool, mute your bad habits and build positive routines.`,
    stack: [{ name: "React Js" }, { name: "Daisyui & Tailwind" }],
    img: habitual_fact,
    live: "https://magical-semifreddo-3d589a.netlify.app/",
    github: "https://github.com/shihab-sa/habitual_fact",
  },
];

// =====================================   Mobile App Project Section  ===================

export const mobile_socialMedia_App = [
  {
    images: "path/to/imag",
    title: "Threads",
    date: "20 Oct 2024",
    category: "iOs",
  },
  {
    images: "path/to/image2.jpg",
    title: "Chatter",
    date: "22 Oct 2024",
  },
  {
    images: "path/to/image3.jpg",
    title: "SnapTalk",
    date: "25 Oct 2024",
  },
  {
    images: "path/to/image4.jpg",
    title: "Buzz",
    date: "28 Oct 2024",
  },
  {
    images: "path/to/image5.jpg",
    title: "LinkUp",
    date: "30 Oct 2024",
  },
];

// =====================================  web app data  =================================

export const web_productivity_app = [
  {
    id: 1,
    images: habitual_fact,
    title: "Habitual Fact",
    urlLink: "https://magical-semifreddo-3d589a.netlify.app/",
  },
  {
    id: 2,
    images: MyLife,
    title: "Life Ratings",
    urlLink: "https://jazzy-sorbet-eea605.netlify.app/",
  },
  {
    id: 3,
    images: RnP,
    title: "Blog Site",
    urlLink: "https://radiant-pixie-37e4fc.netlify.app/",
  },
  {
    id: 4,
    images: karzaHasna,
    title: "Karza Hasna",
    urlLink: "https://timely-granita-c7445f.netlify.app/",
  },
  {
    id: 5,
    images: bhasha_switch,
    title: "Bhasha Switch",
    urlLink: "https://statuesque-stroopwafel-2bace6.netlify.app/",
  },
];
